import env from '../../env';
import { ApiClient, normalizeApiUrl } from '@inspace-org/client';
import { apiCredentials } from './credentials';
import { language } from '../../localization';

export const apiUrl = normalizeApiUrl(env.apiUrl);

export const Client = new ApiClient({ baseUrl: apiUrl, prefix: '/api', credentials: apiCredentials, language });
export const ApiClientV2 = new ApiClient({ baseUrl: apiUrl, prefix: 'api/v2', credentials: apiCredentials, language });
